import {RouteConfig} from "../../config/RouteConfig";
import {
    AccessTimeOutlined,
    AccountTreeOutlined,
    AdminPanelSettingsOutlined,
    AssessmentOutlined,
    BarChartOutlined,
    CalendarMonthOutlined,
    CandlestickChart,
    CandlestickChartOutlined,
    DashboardOutlined,
    GroupsOutlined,
    InboxOutlined,
    OutboxOutlined,
    Person2Outlined,
    PieChartOutlined,
    ReceiptOutlined,
    SsidChartOutlined
} from "@mui/icons-material";

export interface NavDrawerItemIconProps {
    itemIdentifier: string
    itemLink: string
    color?: string
    className?: string
}

export function NavDrawerItemIcon({ itemIdentifier, itemLink, color, className }: NavDrawerItemIconProps) {

    const sharedProps = typeof color !== "undefined"
        ? { style: { color: color ?? 'black' }, className: className }
        : { className: className } as const;

    if( typeof itemIdentifier === "undefined" && itemLink.includes( "/calendar" )) {
        return <CalendarMonthOutlined {...sharedProps} />;
    }

    if( itemLink === "/reporting_employees_hours" ) {
        return <CandlestickChartOutlined {...sharedProps} />;
    }

    switch( itemIdentifier ) {
        case RouteConfig["dashboard"].viewIdentifier:
            return <DashboardOutlined {...sharedProps} />;
        case RouteConfig["timesheet"].viewIdentifier:
            return <AccessTimeOutlined {...sharedProps} />;
        case RouteConfig["employees"].viewIdentifier:
            return <GroupsOutlined {...sharedProps} />;
        case RouteConfig["project"].viewIdentifier:
            return <AccountTreeOutlined {...sharedProps} />;
        case RouteConfig["adminView"].viewIdentifier:
            return <AdminPanelSettingsOutlined {...sharedProps} />;
        case RouteConfig["accountBook"].viewIdentifier:
            return <OutboxOutlined {...sharedProps} />;
        case RouteConfig["incomingInvoice"].viewIdentifier:
            return <InboxOutlined {...sharedProps} />;
        case RouteConfig["projectReport"].viewIdentifier:
            return <BarChartOutlined {...sharedProps} />;
        case RouteConfig["customerRevenueReport"].viewIdentifier:
            return <PieChartOutlined {...sharedProps} />;
        case RouteConfig["projectSolvencyReport"].viewIdentifier:
            return <SsidChartOutlined {...sharedProps} />;
        case "reporting":
            return <AssessmentOutlined {...sharedProps} />;
        case "accounting":
            return <ReceiptOutlined {...sharedProps} />;
        default:
            return null;


    }

}